<template>
  <div class="content">
    <!--    搜索-->
    <div class="search">
      <div class="search-select">
        <div class="text">时间</div>
        <div class="time">
          <div
            class="time-text"
            v-for="(item, index) in timeList"
            :class="isActive === index ? 'active' : ''"
            :key="index"
            @click="selectTime(index)"
          >
            {{ item }}
          </div>
        </div>
        <el-date-picker
          style="width: 268px"
          v-model="time"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="getTime"
        >
        </el-date-picker>
      </div>
      <div class="search-input">
        <el-input
          placeholder="达人昵称/达人ID"
          v-model="searchForm.dyNameOrId"
        ></el-input>
        <div class="button" @click="searchBtn">
          <img src="@/assets/img/dy_home_icon_search.png" alt="" />
        </div>
        <div class="button-reset" @click="resetBtn">重置</div>
      </div>
    </div>
    <!--    交易数据-->
    <div class="box">
      <div class="flex">
        <div class="title">交易数据</div>
        <div class="type-list">
          <div
            class="list-item"
            :class="isActiveType === index ? 'active' : ''"
            v-for="(item, index) in typeList"
            :key="index"
            @click="changeTrading(index)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="home-list">
        <div class="item">
          <div class="item-title">
            {{ info.salesOrderQuantity ? info.salesOrderQuantity : 0 }}
          </div>
          <div class="item-text">销售订单数(含退款)</div>
        </div>
        <div class="item">
          <div class="item-title">
            {{ info.saleOrderAmount ? info.saleOrderAmount : 0 }}
          </div>
          <div class="item-text">销售金额(含退款)(元)</div>
        </div>
        <div class="item">
          <div class="item-title">
            {{ info.refundOrderNum ? info.refundOrderNum : 0 }}
          </div>
          <div class="item-text">退款订单数</div>
        </div>
        <div class="item">
          <div class="item-title">
            {{ info.refundAmount ? info.refundAmount : 0 }}
          </div>
          <div class="item-text">退款金额(元)</div>
        </div>
        <div class="item">
          <div class="item-title">
            {{ info.dealOrderNum ? info.dealOrderNum : 0 }}
          </div>
          <div class="item-text">
            实际成交订单
            <el-tooltip effect="dark" placement="top">
              <i class="el-icon-question"></i>
              <div slot="content">销售订单数 - 退款订单数</div>
            </el-tooltip>
          </div>
        </div>
        <div class="item">
          <div class="item-title">
            {{ info.dealOrderAmount ? info.dealOrderAmount : 0 }}
          </div>
          <div class="item-text">
            实际成交金额
            <el-tooltip effect="dark" placement="top">
              <i class="el-icon-question"></i>
              <div slot="content">销售订单金额 - 退款订单金额</div>
            </el-tooltip>
          </div>
        </div>
        <!-- 主小程序我的预估佣金appCommission 代理预估佣金   dyProxyCommission 否则我的预估佣金dyProxyCommission-->
        <template v-if="isDyAppOwner">
          <div class="item">
            <div class="item-title">
              {{ info.appCommission ? info.appCommission : 0 }}
            </div>
            <div class="item-text">
              我的预估佣金
              <el-tooltip effect="dark" placement="top">
                <i class="el-icon-question"></i>
                <div slot="content">未扣除达人佣金</div>
              </el-tooltip>
            </div>
          </div>
          <div class="item">
            <div class="item-title">
              {{ info.dyProxyCommission ? info.dyProxyCommission : 0 }}
            </div>
            <div class="item-text">代理预估佣金</div>
          </div>
        </template>
        <template v-else>
          <div class="item">
            <div class="item-title">
              {{ info.dyProxyCommission ? info.dyProxyCommission : 0 }}
            </div>
            <div class="item-text">
              我的预估佣金
              <el-tooltip effect="dark" placement="top">
                <i class="el-icon-question"></i>
                <div slot="content">未扣除达人佣金</div>
              </el-tooltip>
            </div>
          </div>
        </template>

        <div class="item">
          <div class="item-title">
            {{ info.dyDarenCommission ? info.dyDarenCommission : 0 }}
          </div>
          <div class="item-text">达人预估佣金</div>
        </div>
      </div>
    </div>
    <!--   直播表格-->
    <div class="box">
      <div class="flex-between">
        <div class="title">直播详细数据</div>
        <div class="button" @click="exportBtn(1)">下载数据</div>
      </div>
      <el-table
        class="table"
        v-loading="searchForm.Loading"
        :data="tableListLive.list"
        border
        highlight-current-row
        style="width: 100%"
        header-row-class-name="header"
      >
        <el-table-column label="直播信息" width="180">
          <template slot-scope="{ row }">
            <div class="flex">
              <div class="image">
                <img :src="row.headImage" alt="" />
              </div>
              <div class="text">
                <div class="title">{{ row.userName }}</div>
                <div class="name">达人ID：{{ row.referenceId }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数据日期" prop="dateTime"> </el-table-column>

        <el-table-column label="支付订单数" prop="payOrderNum"> </el-table-column>
        <el-table-column label="支付订单金额" prop="payOrderAmount">
          <template slot-scope="{ row }">
            <div>{{ row.payOrderAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="退款订单数" prop="refundOrderNum"> </el-table-column>
        <el-table-column label="退款订单金额" prop="refundOrderAmount">
          <template slot-scope="{ row }">
            <div>{{ row.refundOrderAmount }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!--    分页-->
      <el-pagination
        v-if="tableListLive.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="liveCurrentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableListLive.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableListLive.total"
      >
      </el-pagination>
    </div>
    <!--    短视频表格-->
    <div class="box">
      <div class="flex-between">
        <div class="title">短视频详细数据</div>
        <div class="button" @click="exportBtn(2)">下载数据</div>
      </div>
      <el-table
        class="table"
        v-loading="searchForm.Loading"
        :data="tableListShort.list"
        border
        highlight-current-row
        style="width: 100%"
        header-row-class-name="header"
      >
        <el-table-column label="短视频信息" width="180">
          <template slot-scope="{ row }">
            <div class="flex">
              <div class="image">
                <img
                  :src="row.headImage"
                  alt=""
                  style="width: 56px; height: 56px; border-radius: 50%"
                />
              </div>
              <div class="text">
                <div class="title">达人：{{ row.userName }}</div>
                <div class="name">达人ID：{{ row.referenceId }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="数据日期" prop="dateTime"> </el-table-column>
        <el-table-column label="支付订单数" prop="payOrderNum"> </el-table-column>
        <el-table-column label="支付订单金额" prop="payOrderAmount">
          <template slot-scope="{ row }">
            <div>{{ row.payOrderAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="退款订单数" prop="refundOrderNum"> </el-table-column>
        <el-table-column label="退款订单金额" prop="refundOrderAmount">
          <template slot-scope="{ row }">
            <div>{{ row.refundOrderAmount }}</div>
          </template>
        </el-table-column>
      </el-table>
      <!--    分页-->
      <el-pagination
        v-if="tableListShort.total > 0"
        class="pagination"
        @size-change="handleSizeChangeShort"
        @current-change="handleCurrentChangeShort"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableListShort.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableListShort.total"
        :current-page.sync="shortCurrentPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import douYin from "@/javaApi/douyin";

const DouYinModel = new douYin();
import { mapGetters } from "vuex";
export default {
  name: "index",

  data() {
    return {
      timeList: ["今天", "昨日", "前7天", "前30天", "前90天"],
      time: [],
      input: "",
      isActive: 0,
      typeList: ["全部", "直播", "短视频"],
      isActiveType: 0,
      liveCurrentPage: 1, // 直播详情当前页
      tableListLive: {}, // 直播详情数据
      shortCurrentPage: 1, // 短视频详情当前页
      tableListShort: {}, // 短视频详情数据
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        Loading: false,
        dyNameOrId: "",
        beginTime: "",
        endTime: "",
        transactionDataType: 0,
        day: 1,
      },
      currentPage: 1,
      info: {},
      data: {},
      show: false,
      loading: false, // 加载
      pickerOptions: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const minTime = curDate - 90 * 24 * 3600 * 1000; // 90天
          const maxTime = curDate - 1 * 24 * 3600 * 1000; // 昨天
          return time.getTime() > maxTime || time.getTime() < minTime;
        },
      },
    };
  },
  computed: {
    ...mapGetters(["isDyAppOwner"]),
  },
  mounted() {
    this.selectTime();
  },
  methods: {
    /**
     * @description: 选择时间
     * @param {Number} 索引值
     */
    async selectTime(index = 0) {
      this.isActive = index;
      let timeObj = {
        0: 0, // 今天
        1: -1, // 昨天
        2: 7, // 近7天
        3: 30, // 近30天
        4: 90, // 近90天
      };
      this.computationDate(timeObj[index]);
      this.getDataInfo();
      this.getList();
      this.getListShort();
    },
    // 点击交易构成
    changeTrading(index) {
      this.isActiveType = index;
      this.searchForm.transactionDataType = index;
      this.getDataInfo();
    },
    selectType(index) {
      this.isActiveType = index;
      this.searchForm.transactionDataType = index;
      this.getDataInfo();
      this.getList();
      this.getListShort();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleSizeChangeShort(val) {
      this.searchForm.pageSize = val;
      this.getListShort();
    },
    handleCurrentChangeShort(val) {
      this.searchForm.pageNo = val;
      this.getListShort();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
    getDataInfo() {
      DouYinModel.getTransactionData({
        ...this.searchForm,
        miniAppType: 5,
      }).then((res) => {
        if (res.data.code === 200) {
          this.info = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getList() {
      this.searchForm.Loading = true;

      DouYinModel.getLiveDetail({
        ...this.searchForm,
        miniAppType: 5,
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableListLive = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
        this.searchForm.Loading = false;
      });
    },
    getListShort() {
      this.searchForm.Loading = true;

      DouYinModel.getVideoDetail({
        ...this.searchForm,
        miniAppType: 5,
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableListShort = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
        this.searchForm.Loading = false;
      });
    },
    getTime(e) {
      if (e && e.length) {
        // 结束时间修改成23:59:59，剔除原本时间的时分秒
        let time = e[1].split(" ");
        this.searchForm.beginTime = e[0];
        this.searchForm.endTime = time[0];
        this.searchForm.day = "";
        this.isActive = this.timeList.length + 1;
        this.getDataInfo();
        this.getList();
        this.getListShort();
      }
    },
    computationDate(count) {
      // 昨天
      if (count === -1) {
        let date = new Date();
        date.setDate(date.getDate() - 1);
        let yesterday =
          date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        this.searchForm.beginTime = yesterday;
        this.searchForm.endTime = yesterday;
        this.time = [];
        return;
      }

      const nowDate = new Date();
      let current_date = "";
      if (count !== 0) {
        current_date = nowDate.getDate() - 1;
      } else {
        current_date = nowDate.getDate();
      }

      const current_month = nowDate.getMonth() + 1;
      const current_year = nowDate.getFullYear();
      let date = new Date();
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * count);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      this.searchForm.beginTime = year + "-" + month + "-" + day;
      this.searchForm.endTime = current_year + "-" + current_month + "-" + current_date;
      this.time = [];
    },
    searchBtn() {
      this.liveCurrentPage = 1;
      this.shortCurrentPage = 1;
      this.searchForm.pageNo = 1;
      this.getList();
      this.getListShort();
      this.getDataInfo();
    },
    resetBtn() {
      this.liveCurrentPage = 1;
      this.shortCurrentPage = 1;
      this.searchForm.pageNo = 1;
      this.searchForm.pageSize = 10;
      this.searchForm.dyNameOrId = "";
      this.getDataInfo();
      this.getList();
      this.getListShort();
    },
    exportBtn(index) {
      this.searchForm.transactionDataType = index;
      this.searchForm.pageNo = "";
      this.searchForm.pageSize = "";
      if (index === 1) {
        DouYinModel.liveExportData({
          ...this.searchForm,
          miniAppType: 5,
        }).then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);
          a.download =
            index === 1
              ? "直播列表"
              : "短视频列表" + this.formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
          this.$message({
            message: "导出成功",
            type: "success",
          });
        });
      } else {
        DouYinModel.videoExportData({
          ...this.searchForm,
          miniAppType: 5,
        }).then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);
          a.download =
            index === 1
              ? "直播列表"
              : "短视频列表" + this.formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
          this.$message({
            message: "导出成功",
            type: "success",
          });
        });
      }
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + m + d;
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;

  .search {
    background: #ffffff;
    border-radius: 8px;
    padding: 26px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    .search-select {
      display: flex;
      align-items: center;

      .text {
        font-size: 14px;
        font-family: AlibabaPuHuiTi_2_55_Regular;
        color: #666666;
        line-height: 20px;
      }

      .time {
        display: flex;
        border-radius: 2px;
        border: 1px solid #f0f1f5;
        margin-left: 10px;
        margin-right: 20px;

        .time-text {
          width: 76px;
          height: 32px;
          font-size: 14px;
          font-family: AlibabaPuHuiTi_2_55_Regular;
          color: #666666;
          line-height: 32px;
          text-align: center;
          border-right: 1px solid #f0f1f5;
          cursor: pointer;
        }
      }
    }

    .search-input {
      width: 234px;
      display: flex;
      align-items: center;

      .button {
        width: 36px;
        height: 32px;
        background: #ff8622;
        border-radius: 0px 2px 2px 0px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .button-reset {
        background: #ff8622;
        border-radius: 2px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        width: 70px;
        text-align: center;
        color: #fff;
        margin-left: 10px;
      }
    }
  }

  .box {
    padding: 20px 21px;
    background: #ffffff;
    border-radius: 8px;
    margin-top: 16px;

    .flex {
      display: flex;
      align-items: center;

      .image {
        img {
          width: 32px;
          height: 32px;
          border-radius: 100%;
        }
      }

      .text {
        margin-left: 10px;
        text-align: left;

        .name {
          font-size: 12px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #666666;
          line-height: 17px;
        }

        .title {
          font-size: 13px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #333333;
          line-height: 18px;
        }
      }

      .title {
        font-size: 18px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 25px;
      }

      .type-list {
        display: flex;
        border-radius: 2px;
        border: 1px solid #f0f1f5;
        margin-left: 20px;
        margin-right: 20px;

        .list-item {
          width: 76px;
          height: 32px;
          font-size: 14px;
          font-family: AlibabaPuHuiTi_2_55_Regular;
          color: #666666;
          line-height: 32px;
          text-align: center;
          border-right: 1px solid #f0f1f5;
          cursor: pointer;
        }
      }

      .data-box {
        background-image: url("../../../../assets/img/dy_home_jygc_bg_1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 208px;
        height: 93px;
        margin-right: 20px;
        margin-top: 12px;
        padding: 16px 20px;

        .data-box-top {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .top-number {
            font-size: 24px;
            font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #333333;
            line-height: 33px;
          }

          .top-text {
            font-size: 16px;
            font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #ff4f76;
            line-height: 22px;
          }
        }

        .data-box-text {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #666666;
          line-height: 20px;
        }
      }
    }

    .flex-between {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .item {
        width: 16%;
        padding: 24px 10px;

        .item-title {
          font-size: 24px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #333333;
          line-height: 33px;
        }

        .item-text {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #999999;
          line-height: 20px;
        }
      }

      .title {
        font-size: 18px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 25px;
      }

      .button {
        width: 96px;
        height: 28px;
        background: #ff8622;
        border-radius: 2px;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .active {
    background: #ff8622 !important;
    color: #ffffff !important;
  }

  .imageBg {
    background-image: url("../../../../assets/img/dy_home_jygc_bg_2.png") !important;
  }
}

.table {
  margin-top: 12px;
}

.pagination {
  text-align: right;
  margin-top: 12px;
}

/deep/ .el-input__inner {
  border-radius: 2px !important;
  height: 32px;
}

/deep/ .el-input__inner:focus {
  border-color: #ff8622 !important;
}

/deep/ .el-date-editor .el-range-separator {
  line-height: 25px !important;
}

/deep/ .el-date-editor .el-range__icon {
  line-height: 25px !important;
}

/deep/ .el-date-editor .el-range__close-icon {
  line-height: 25px !important;
}

/deep/ .el-tabs__item.is-active {
  color: #ff8622 !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #ff8622 !important;
}

/deep/ .el-tabs__item:hover {
  color: #ff8622 !important;
}

/deep/ .el-table th,
.el-table tr {
  background-color: #fcfaf8;
}

.home-list {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 194px;
    padding: 18px;

    &-title {
      font-size: 24px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 33px;
    }

    &-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/home/index.vue